/* eslint-disable */
// src/layouts/machine/data/machineTableData.js

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import React from "react";

import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import RestoreIcon from "@mui/icons-material/Restore";
import Chip from "@mui/material/Chip";
import { getMachineStatusLabel } from "utils/statusLabels";
import { getMachineCurrentLocationName } from "utils/machineCurrentLocation";
import machineDisplayName from "layouts/machine/data/machineDisplayName";

function statusChip(status) {
  switch (status) {
    case "Available":
      return <Chip label={getMachineStatusLabel(status)} size="small" />;
    case "InUse":
      return <Chip label={getMachineStatusLabel(status)} color="info" size="small" />;
    case "Eliminated":
      return <Chip label={getMachineStatusLabel(status)} color="error" size="small" />;
    default:
      return <Chip label={getMachineStatusLabel(status, "—")} size="small" />;
  }
}

export default function machineTableData({
  machinesDetails,
  onEdit,
  onDelete,
  onReactivate,
  hideDelete = false,
  hideTypeColumn = false,
  typeFirst = false,
  expectedLocalType = "Depósito",
}) {
  const nameColumn = {
    Header: "Nombre",
    accessor: "Name",
    align: "left",
    Cell: ({ value }) => (
      <span
        style={{
          display: "inline-block",
          maxWidth: 240,
          whiteSpace: "normal",
          overflowWrap: "anywhere",
        }}
      >
        {value}
      </span>
    ),
  };
  const typeColumn = {
    Header: typeFirst ? "Tipo" : "Tipo de Máquina",
    accessor: "MachineTypeType",
    align: "left",
  };
  return {
    columns: [
      ...(typeFirst && !hideTypeColumn ? [typeColumn] : []),
      nameColumn,
      ...(!typeFirst && !hideTypeColumn ? [typeColumn] : []),
      {
        Header: "Ubicación",
        accessor: "CurrentLocation",
        align: "left",
        Cell: ({ value }) => (
          <span
            style={{
              display: "inline-block",
              maxWidth: 240,
              whiteSpace: "normal",
              overflowWrap: "anywhere",
            }}
          >
            {value}
          </span>
        ),
      },
      { Header: "", accessor: "Actions", align: "left" },
    ],

    rows: machinesDetails.map((machine) => ({
      Name: machineDisplayName(machine),
      MachineTypeType: machine?.MachineType?.Type ?? "No asignado",
      CurrentLocation: getMachineCurrentLocationName(machine, expectedLocalType),
      Actions: (
        <MDBox>
          <IconButton
            name="updateMachine"
            aria-label="Editar máquina"
            color="primary"
            onClick={() => onEdit(machine.Id)}
          >
            <DriveFileRenameOutlineIcon />
          </IconButton>
          {!hideDelete && (
            <IconButton
              name="deleteMachine"
              aria-label="Eliminar máquina"
              color="secondary"
              onClick={() => onDelete(machine.Id)}
              disabled={machine.Status === "InUse"}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </MDBox>
      ),
    })),
  };
}

machineTableData.propTypes = {
  machinesDetails: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  hideDelete: PropTypes.bool,
  hideTypeColumn: PropTypes.bool,
  typeFirst: PropTypes.bool,
  expectedLocalType: PropTypes.string,
};
